import { toIsoDate } from "@common/helpers/date";
import {
    CollectedExtraction,
    CoverageRow,
    Period,
    RequirementKey,
    UnmatchedDoc,
    UnmatchedReason,
} from "./types";

export function coverageMatchedRow(args: {
    key: RequirementKey;
    doc: CollectedExtraction;
    period: Period | null;
}): CoverageRow {
    const { key, doc, period } = args;
    return {
        key: `${key}:${doc.documentId}`,
        requirementKey: key,
        period,
        status: "ready",
        documentId: doc.documentId,
        fileName: doc.fileName,
        summary: doc.summary,
        statusMessage: doc.statusMessage,
    };
}

export function coverageAwaitingRow(args: {
    key: RequirementKey;
    start: Date;
    end: Date;
}): CoverageRow {
    const { key, start, end } = args;
    const startIso = toIsoDate(start);
    return {
        key: `${key}:awaiting:${startIso}`,
        requirementKey: key,
        period: { start: startIso, end: toIsoDate(end) },
        status: "awaiting",
    };
}

export function coverageRequirementAwaitingRow(
    key: RequirementKey,
    period: Period | null,
): CoverageRow {
    return {
        key,
        requirementKey: key,
        period,
        status: "awaiting",
    };
}

export function coverageUnmatchedDoc(
    doc: CollectedExtraction,
    reason: Extract<
        UnmatchedReason,
        "overlap" | "outside_period" | "no_transactions" | "duplicate"
    >,
): UnmatchedDoc {
    return {
        documentId: doc.documentId,
        fileName: doc.fileName,
        status: "unrecognized",
        reason,
        period: doc.period ?? null,
    };
}
